import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import { linearProgressClasses } from '@mui/material';

export const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 8,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#E2DEFA',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#6C59E6',
  },
}));
